<!--  -->
<template>
  <div>
    <el-input v-model="openid" placeholder="请输入open_id" style="width:200px" />
    <div style="margin-top:20px">
      <el-button type="primary" size="mini" @click="dawr">确定</el-button>
    </div>
  </div>
</template>

<script>
import { testbind } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      bind_id: null,
      openid: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(id) {
      this.bind_id = id
    },
    async dawr() {
      if (this.openid === '') {
        this.$message.error('请输入openid')
        return
      }
      const data = await testbind({
        bind_id: this.bind_id,
        open_id: this.openid
      })
      this.$message({
        message: '发送成功',
        type: 'success'
      })
      this.$emit('callupdata')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
